define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SmaPermitTypeDomain = void 0;
    class SmaPermitTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SmaPermitTypeDomain.AllPermitTypes, value: "All Permit Types" },
                    { key: SmaPermitTypeDomain.TravelPermit, value: "Travel Permit" },
                    { key: SmaPermitTypeDomain.GrazingPermit, value: "Grazing Permit" },
                    { key: SmaPermitTypeDomain.HarvestingPermit, value: "Harvesting Permit" },
                    { key: SmaPermitTypeDomain.GrazingAuthority, value: "Grazing Authority" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SmaPermitTypeDomain.AllPermitTypes] = 0;
                this.KeyIndex[SmaPermitTypeDomain.TravelPermit] = 1;
                this.KeyIndex[SmaPermitTypeDomain.GrazingPermit] = 2;
                this.KeyIndex[SmaPermitTypeDomain.HarvestingPermit] = 3;
                this.KeyIndex[SmaPermitTypeDomain.GrazingAuthority] = 4;
                this.ValueIndex = {};
                this.ValueIndex["All Permit Types"] = 0;
                this.ValueIndex["Travel Permit"] = 1;
                this.ValueIndex["Grazing Permit"] = 2;
                this.ValueIndex["Harvesting Permit"] = 3;
                this.ValueIndex["Grazing Authority"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SmaPermitTypeDomain = SmaPermitTypeDomain;
    Object.defineProperty(SmaPermitTypeDomain, "AllPermitTypes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: -1
    });
    Object.defineProperty(SmaPermitTypeDomain, "TravelPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(SmaPermitTypeDomain, "GrazingPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(SmaPermitTypeDomain, "HarvestingPermit", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(SmaPermitTypeDomain, "GrazingAuthority", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(SmaPermitTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
